import {useState} from "react"

export const useSidebar = (initOpen = true, initDisabled = false) => {
    const [stateOpen, setStateOpen] = useState(initOpen)
    const [stateDisabled, setStateDisabled] = useState(initDisabled)
    let toggleCallback = null

    const toggle = () => {
        if(isDisable()) return
        if(toggleCallback) toggleCallback()
        else setStateOpen(prevOpen => !prevOpen)
    }

    const isOpen = () => {
        if(isDisable()) return false
        return stateOpen
    }

    const open = () => {
        setStateOpen(true)
    }

    const onToggleCallback = (onClose) => {
        toggleCallback = onClose
    }

    const isClose = () => {
        if(isDisable()) return true
        return !stateOpen
    }

    const close = () => {
        setStateOpen(false)
    }

    const isDisable = () => {
        return stateDisabled
    }

    const enable = () => {
        setStateDisabled(false)
    }

    const disable = () => {
        setStateDisabled(true)
    }

    return {
        toggle, isOpen, open, isClose, close, onToggleCallback, isDisable, enable, disable
    }
}